/** @jsx jsx */

import React, { useEffect, useRef, useState } from "react";
import { jsx, css } from "@emotion/react";

const imgDiv = css`
  display: flex;
  justify-content: left;
`;

const img = css`
  width: 90%;
  height: auto;
  padding-top:1em;
`;

const hiddenDiv = css`
  display: none;
`;

const onePadding = css`
  padding-top:1em;
`;

type ScreenShotTakerProps = {
  videoSrc: Blob | undefined,
  videoType: string | undefined,
  isSafari: boolean | undefined,
  screenTimePercent: number
}

const ScreenShotTaker: React.FC<ScreenShotTakerProps> = ({ videoSrc, videoType, isSafari, screenTimePercent }) => {
  const playerRef = useRef<null | HTMLVideoElement>(null);
  const vSrc = videoSrc;
  const vType = videoType;
  const [imgPreviewSrc, setImgPreviewSrc] = useState<string>("");
  useEffect(() => {
    let video = playerRef.current;
    video?.load();
    var eventsArray: Array<string> = [];
    if (isSafari) {
      eventsArray.push("canplay");
    } else {
      eventsArray.push("loadedmetadata");
    }
    video?.addEventListener(eventsArray[0], (evt) => {
      (video != null) ? (video.currentTime = ((video?.duration * screenTimePercent) / 100)) : null;
      video?.addEventListener("timeupdate", (evt) => {
        captureScreenShot(video);
      }, { once: true });
    }, { once: true });
  });

  const captureScreenShot = ((video) => {
    var canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext('2d');
    ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
    let dataURI = canvas.toDataURL('image/jpeg');
    setImgPreviewSrc(dataURI);
  });


  return (
    <div css={onePadding}>
      <div css={hiddenDiv}>
        <video ref={playerRef} controls width="100%" height="auto">
          <source src={!vSrc ? undefined : URL.createObjectURL(vSrc)} type={vType}>
          </source>
        </video>
      </div>
      <div css={imgDiv}>
        <img css={img} src={imgPreviewSrc} />
      </div>
    </div>
  )
};

export default ScreenShotTaker;

